var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M27.495 16.465c-.026-4.178-3.37-7.965-7.488-7.965-4.111 0-7.447 3.77-7.488 7.936a.1.1 0 0 0-.02.05v9.421c0 .88.734 1.593 1.638 1.593h11.726c.905 0 1.637-.714 1.637-1.593v-9.422q-.002-.01-.005-.02Zm-13.018-.444c.244-2.92 2.626-5.554 5.529-5.554s5.286 2.634 5.529 5.556c-2.87-.262-8.181-.263-11.058-.002Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M21.734 20.303c0-.918-.748-1.662-1.672-1.662-.922 0-1.67.744-1.67 1.662 0 .7.435 1.298 1.05 1.543v1.533a.591.591 0 0 0 1.185 0v-1.513a1.66 1.66 0 0 0 1.107-1.563Z"
}))));
export default SvgLocker;